import { AxiosResponse } from 'axios';
import { ApplicationReadDto } from '__generated__/api';
import { http } from '../http';

export async function getApplicationRequestDetails(id: number): Promise<ApplicationReadDto> {
  const url = `/api/applicationregistration/${id}`;
  const response = await http.get(url);
  return response.data;
}

export async function updateApplicationDetails(formData: any) {
  try {
    const response = await http({
      url: '/api/applicationregistration',
      method: 'POST',
      data: JSON.stringify(formData),
    });
    return { data: response.data, status: 200 };
  } catch (err: any) {
    throw err;
  }
}

export async function applicationRegistration(formData: any) {
  const response: AxiosResponse<ApplicationReadDto> = await http({
    url: '/api/applicationregistration',
    method: 'POST',
    data: JSON.stringify(formData),
  });
  return response;
}

export async function sendAsrApplication(formData: any) {
  const url = '/api/applicationregistration/submit';
  try {
    const response = await http.post<{}>(url, JSON.stringify(formData), {
      headers: {
        Accept: '*/*',
      },
    });
    return { data: response.data, status: 200 };
  } catch (err: any) {
    throw err;
  }
}

export async function validateNewBtlApplication(newBtlApplication: ApplicationReadDto) {
  const url = '/api/applicationregistration/validate';

  try {
    const response = await http.post(url, JSON.stringify(newBtlApplication), {
      headers: {
        Accept: '*/*',
        AuthorizedCommercialLabels: 25,
      },
    });
    return { data: response.data, status: 200 };
  } catch (err: any) {
    throw err;
  }
}

export const deleteApplication = async (id: number | undefined) => {
  const response = await http({
    url: `/api/applicationregistration/${id}`,
    method: 'DELETE',
  });
  return { response };
};
